import React from "react";
import Content from "./Content";

export default function Hero({ backgroundImage, children }) {
  return (
    <div
      style={{
        backgroundImage: backgroundImage ? `url(${backgroundImage})` : "none",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
      className="p-4 sm:p-12"
    >
      <Content>{children}</Content>
    </div>
  );
}
